module.exports = __webpack_public_path__ + "static/media/surprise-meal1.d9917e0c.png";